module.exports = "/images/vendor/desiigner-svg/svg/ui/pause.svg?4f4a4305a1126aa919c3b85327c898f6";